// extracted by extract-css-chunks-webpack-plugin
module.exports = {"grid":"app-components-profile-profileform--grid","avatar":"app-components-profile-profileform--avatar"};